import { useHelpdeskControllerCreateTicket } from '@safc/api-client';
import { useMachine } from '@xstate/react';
import _html2canvas from 'html2canvas';
import { fromPromise } from 'xstate';

import type { ReportingType } from './Helpdesk.constants.js';
import { modalId } from './Helpdesk.constants.js';
import { createHelpdeskTicketMachine } from './Helpdesk.machine.js';
import type {
  HelpdeskContextContext,
  HelpdeskModalState,
} from './Helpdesk.types.js';
import { getBlobFromCanvas } from './Helpdesk.utils.js';

const html2canvas = _html2canvas as any as typeof _html2canvas['default'];

export const useHelpdeskEffects = () => {
  const { mutateAsync: createHelpdeskTicket }
    = useHelpdeskControllerCreateTicket();

  const [helpdeskState, send] = useMachine(createHelpdeskTicketMachine.provide({
    actors: {
      createTicket: fromPromise(async ({ input: ctx }) => {
        let screenshotToSend: Blob[] = [];

        if (ctx.data.screenshot) {
          const canvas = await html2canvas(document.documentElement, {
            ignoreElements: ({ id }) => id === modalId,
          });
          const blob = await getBlobFromCanvas(canvas);
          screenshotToSend = blob ? [blob] : [];
        }

        await createHelpdeskTicket({
          data: {
            description: ctx.data.description,
            screenshots: screenshotToSend,
            url: window.location.href,
            type: ctx.data.type as ReportingType,
          },
        });
      }),
    },
  }), {});

  const createTicket = (data: HelpdeskContextContext['data']) => {
    send({ type: 'CREATE_TICKET', data });
  };

  const openModal = () => {
    send({ type: 'OPEN_MODAL' });
  };

  const closeModal = () => {
    send({ type: 'CLOSE_MODAL' });
  };

  const { modalOpen, errorMessage } = helpdeskState.context;

  return {
    modalId,
    isHelpdeskModalOpen: modalOpen,
    onCloseHelpdeskModal: closeModal,
    onHelpdeskButtonClick: openModal,
    modalState: helpdeskState.value as HelpdeskModalState,
    errorMessage,
    onCreateTicket: createTicket,
  };
};
